import { PartnerService, UserService } from "@duck/api-definitions"

export interface CohortPersonDetails {
  personId: string
  email: string
  onboardingStatus: UserService.PersonOnboardingStatusEnum
  assignmentStatus?: PartnerService.AssignmentDetailsStatus
  grade?: number
  feedback?: string
  solution?: string
  createdAt?: string
  startDate?: string
  submitDate?: string
  workTime?: number
  charts?: PartnerService.AssignmentDetails['charts']
}

interface CohortPageData {
  allPersons: Array<CohortPersonDetails>
  taskAssignments: Record<string, CohortPersonDetails[]>
}
  
  export const buildCohortPageData = (
    cohort: PartnerService.Cohort,
    assignmentsDetails: PartnerService.AssignmentDetails[],
    persons: UserService.Person[]
  ): CohortPageData => {
    const personsMap = persons.reduce((acc, person) => {
      acc[person.id] = person
      return acc
    }, {} as Record<string, UserService.Person>)
  
  
    const allPersons: Array<CohortPersonDetails> =
      cohort.personIds
        ?.filter((personId) => personsMap[personId])
        .map((personId) => {
          const person = personsMap[personId]
          // Find ANY ONE assignment
          const assignmentDetails = assignmentsDetails.find(
            (ad) => ad.personId === personId
          )
          return {
            personId,
            email: person.email,
            onboardingStatus: person.onboardingStatus,
            assignmentStatus: assignmentDetails?.status ?? undefined,
            grade: assignmentDetails?.grade ?? undefined,
            feedback: assignmentDetails?.feedback ?? undefined,
            solution: assignmentDetails?.solution ?? undefined,
            createdAt: person.createdAt,
            startDate: assignmentDetails?.startDate ?? undefined,
            submitDate: assignmentDetails?.submitDate ?? undefined,
            workTime: assignmentDetails?.workTime ?? undefined,
            charts: assignmentDetails?.charts ?? undefined,
          }
        })
        .sort((a, b) => {
          const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0
          const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0
          return bTime - aTime // Descending order (latest first)
        }) ?? []
  
    const taskAssignments: Record<string, CohortPersonDetails[]> = {}
    assignmentsDetails.forEach(assignmentDetails => {
      if (!taskAssignments[assignmentDetails.taskId]) {
        taskAssignments[assignmentDetails.taskId] = []
      }
      taskAssignments[assignmentDetails.taskId].push({
        personId: assignmentDetails.personId,
        email: personsMap[assignmentDetails.personId].email,
        onboardingStatus: personsMap[assignmentDetails.personId].onboardingStatus,
        createdAt: personsMap[assignmentDetails.personId].createdAt,
        assignmentStatus: assignmentDetails.status,
        grade: assignmentDetails.grade,
        feedback: assignmentDetails.feedback,
        solution: assignmentDetails.solution,
        startDate: assignmentDetails.startDate,
        submitDate: assignmentDetails.submitDate,
        workTime: assignmentDetails.workTime,
        charts: assignmentDetails.charts,
      })
    })
  
    return { allPersons, taskAssignments }
  }